import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=8ff62cf8&scoped=true&"
import script from "./admin.vue?vue&type=script&lang=js&"
export * from "./admin.vue?vue&type=script&lang=js&"
import style0 from "./admin.vue?vue&type=style&index=0&id=8ff62cf8&lang=less&scoped=true&"
import style1 from "./admin.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff62cf8",
  null
  
)

export default component.exports